import { Spinner } from '@nextui-org/spinner'

import styles from './styles.module.css'

export default function Loading() {
  return (
    <div className={styles.containerLoading}>
      <Spinner />
    </div>
  )
}
